import {
  Companion_getInstance35jta5xdhkpv2 as Companion_getInstance,
  FunnelSummary2xkqtzvrnqmvn as FunnelSummary,
} from './models.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { Level3nkvlyj1o3kmm as Level } from '../serverhealth/HealthStatus.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareFunnelSummaryFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [FunnelSummary__id_getInstance(), FunnelSummary_funnel_getInstance(), FunnelSummary_date_getInstance(), FunnelSummary_status_getInstance(), FunnelSummary_success_getInstance(), FunnelSummary_successAfterError_getInstance(), FunnelSummary_error_getInstance(), FunnelSummary_abandoned_getInstance(), FunnelSummary_count_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function FunnelSummary__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function FunnelSummary__id$_get_name_$ref_jxooig() {
  return (p0) => p0.k20();
}
function FunnelSummary__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelSummary__id$_get_serializer_$ref_uhmclb() {
  return (p0) => p0.j2j();
}
function FunnelSummary__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function FunnelSummary__id$_get_annotations_$ref_x5musj() {
  return (p0) => p0.bz();
}
var FunnelSummary__idClass;
function FunnelSummary__id() {
  if (FunnelSummary__idClass === VOID) {
    class $ {
      constructor() {
        FunnelSummary__id_instance = this;
        var tmp = this;
        tmp.m3c_1 = lazy(FunnelSummary__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n3c_1 = lazy(FunnelSummary__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o3c_1 = lazy(FunnelSummary__id$annotations$delegate$lambda);
        this.p3c_1 = Companion_getInstance_0().m2p();
        this.q3c_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.m3c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelSummary__id$_get_name_$ref_jxooig(), null);
        return tmp0.f2();
      }
      r3c(receiver) {
        return receiver.s3c_1;
      }
      m2j(receiver) {
        return this.r3c(receiver instanceof FunnelSummary() ? receiver : THROW_CCE());
      }
      b3d(receiver, value) {
        return receiver.c3d(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FunnelSummary() ? receiver : THROW_CCE();
        return this.b3d(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n3c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelSummary__id$_get_serializer_$ref_uhmclb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o3c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelSummary__id$_get_annotations_$ref_x5musj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelSummary__id', VOID, VOID, [SerializableProperty()]);
    FunnelSummary__idClass = $;
  }
  return FunnelSummary__idClass;
}
var FunnelSummary__id_instance;
function FunnelSummary__id_getInstance() {
  if (FunnelSummary__id_instance === VOID)
    new (FunnelSummary__id())();
  return FunnelSummary__id_instance;
}
function FunnelSummary_funnel$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function FunnelSummary_funnel$_get_name_$ref_6jhqy6() {
  return (p0) => p0.k20();
}
function FunnelSummary_funnel$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelSummary_funnel$_get_serializer_$ref_ar9dyx() {
  return (p0) => p0.j2j();
}
function FunnelSummary_funnel$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function FunnelSummary_funnel$_get_annotations_$ref_5ks6al() {
  return (p0) => p0.bz();
}
var FunnelSummary_funnelClass;
function FunnelSummary_funnel() {
  if (FunnelSummary_funnelClass === VOID) {
    class $ {
      constructor() {
        FunnelSummary_funnel_instance = this;
        var tmp = this;
        tmp.d3d_1 = lazy(FunnelSummary_funnel$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e3d_1 = lazy(FunnelSummary_funnel$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f3d_1 = lazy(FunnelSummary_funnel$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.d3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelSummary_funnel$_get_name_$ref_6jhqy6(), null);
        return tmp0.f2();
      }
      r3c(receiver) {
        return receiver.t3c_1;
      }
      m2j(receiver) {
        return this.r3c(receiver instanceof FunnelSummary() ? receiver : THROW_CCE());
      }
      g3d(receiver, value) {
        return receiver.c3d(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FunnelSummary() ? receiver : THROW_CCE();
        return this.g3d(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelSummary_funnel$_get_serializer_$ref_ar9dyx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelSummary_funnel$_get_annotations_$ref_5ks6al(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelSummary_funnel', VOID, VOID, [SerializableProperty()]);
    FunnelSummary_funnelClass = $;
  }
  return FunnelSummary_funnelClass;
}
var FunnelSummary_funnel_instance;
function FunnelSummary_funnel_getInstance() {
  if (FunnelSummary_funnel_instance === VOID)
    new (FunnelSummary_funnel())();
  return FunnelSummary_funnel_instance;
}
function FunnelSummary_date$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function FunnelSummary_date$_get_name_$ref_rd1iwm() {
  return (p0) => p0.k20();
}
function FunnelSummary_date$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelSummary_date$_get_serializer_$ref_gvpodt() {
  return (p0) => p0.j2j();
}
function FunnelSummary_date$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function FunnelSummary_date$_get_annotations_$ref_su3ded() {
  return (p0) => p0.bz();
}
var FunnelSummary_dateClass;
function FunnelSummary_date() {
  if (FunnelSummary_dateClass === VOID) {
    class $ {
      constructor() {
        FunnelSummary_date_instance = this;
        var tmp = this;
        tmp.h3d_1 = lazy(FunnelSummary_date$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i3d_1 = lazy(FunnelSummary_date$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j3d_1 = lazy(FunnelSummary_date$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.h3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelSummary_date$_get_name_$ref_rd1iwm(), null);
        return tmp0.f2();
      }
      r3c(receiver) {
        return receiver.u3c_1;
      }
      m2j(receiver) {
        return this.r3c(receiver instanceof FunnelSummary() ? receiver : THROW_CCE());
      }
      k3d(receiver, value) {
        return receiver.c3d(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FunnelSummary() ? receiver : THROW_CCE();
        return this.k3d(tmp, value instanceof LocalDate() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelSummary_date$_get_serializer_$ref_gvpodt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelSummary_date$_get_annotations_$ref_su3ded(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelSummary_date', VOID, VOID, [SerializableProperty()]);
    FunnelSummary_dateClass = $;
  }
  return FunnelSummary_dateClass;
}
var FunnelSummary_date_instance;
function FunnelSummary_date_getInstance() {
  if (FunnelSummary_date_instance === VOID)
    new (FunnelSummary_date())();
  return FunnelSummary_date_instance;
}
function FunnelSummary_status$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function FunnelSummary_status$_get_name_$ref_e699f6() {
  return (p0) => p0.k20();
}
function FunnelSummary_status$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelSummary_status$_get_serializer_$ref_ijmlvv() {
  return (p0) => p0.j2j();
}
function FunnelSummary_status$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function FunnelSummary_status$_get_annotations_$ref_9g4nvr() {
  return (p0) => p0.bz();
}
var FunnelSummary_statusClass;
function FunnelSummary_status() {
  if (FunnelSummary_statusClass === VOID) {
    class $ {
      constructor() {
        FunnelSummary_status_instance = this;
        var tmp = this;
        tmp.l3d_1 = lazy(FunnelSummary_status$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m3d_1 = lazy(FunnelSummary_status$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n3d_1 = lazy(FunnelSummary_status$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.l3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelSummary_status$_get_name_$ref_e699f6(), null);
        return tmp0.f2();
      }
      r3c(receiver) {
        return receiver.v3c_1;
      }
      m2j(receiver) {
        return this.r3c(receiver instanceof FunnelSummary() ? receiver : THROW_CCE());
      }
      o3d(receiver, value) {
        return receiver.c3d(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FunnelSummary() ? receiver : THROW_CCE();
        return this.o3d(tmp, value instanceof Level() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelSummary_status$_get_serializer_$ref_ijmlvv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelSummary_status$_get_annotations_$ref_9g4nvr(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelSummary_status', VOID, VOID, [SerializableProperty()]);
    FunnelSummary_statusClass = $;
  }
  return FunnelSummary_statusClass;
}
var FunnelSummary_status_instance;
function FunnelSummary_status_getInstance() {
  if (FunnelSummary_status_instance === VOID)
    new (FunnelSummary_status())();
  return FunnelSummary_status_instance;
}
function FunnelSummary_success$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function FunnelSummary_success$_get_name_$ref_rvafi9() {
  return (p0) => p0.k20();
}
function FunnelSummary_success$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelSummary_success$_get_serializer_$ref_85a44o() {
  return (p0) => p0.j2j();
}
function FunnelSummary_success$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function FunnelSummary_success$_get_annotations_$ref_fh1ld8() {
  return (p0) => p0.bz();
}
var FunnelSummary_successClass;
function FunnelSummary_success() {
  if (FunnelSummary_successClass === VOID) {
    class $ {
      constructor() {
        FunnelSummary_success_instance = this;
        var tmp = this;
        tmp.p3d_1 = lazy(FunnelSummary_success$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q3d_1 = lazy(FunnelSummary_success$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r3d_1 = lazy(FunnelSummary_success$annotations$delegate$lambda);
        this.s3d_1 = 0.0;
        this.t3d_1 = '0f';
      }
      k20() {
        var tmp0 = this.p3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelSummary_success$_get_name_$ref_rvafi9(), null);
        return tmp0.f2();
      }
      r3c(receiver) {
        return receiver.w3c_1;
      }
      m2j(receiver) {
        return this.r3c(receiver instanceof FunnelSummary() ? receiver : THROW_CCE());
      }
      u3d(receiver, value) {
        return receiver.c3d(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FunnelSummary() ? receiver : THROW_CCE();
        return this.u3d(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelSummary_success$_get_serializer_$ref_85a44o(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelSummary_success$_get_annotations_$ref_fh1ld8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelSummary_success', VOID, VOID, [SerializableProperty()]);
    FunnelSummary_successClass = $;
  }
  return FunnelSummary_successClass;
}
var FunnelSummary_success_instance;
function FunnelSummary_success_getInstance() {
  if (FunnelSummary_success_instance === VOID)
    new (FunnelSummary_success())();
  return FunnelSummary_success_instance;
}
function FunnelSummary_successAfterError$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function FunnelSummary_successAfterError$_get_name_$ref_mh3owj() {
  return (p0) => p0.k20();
}
function FunnelSummary_successAfterError$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelSummary_successAfterError$_get_serializer_$ref_sia7bo() {
  return (p0) => p0.j2j();
}
function FunnelSummary_successAfterError$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function FunnelSummary_successAfterError$_get_annotations_$ref_njzc48() {
  return (p0) => p0.bz();
}
var FunnelSummary_successAfterErrorClass;
function FunnelSummary_successAfterError() {
  if (FunnelSummary_successAfterErrorClass === VOID) {
    class $ {
      constructor() {
        FunnelSummary_successAfterError_instance = this;
        var tmp = this;
        tmp.v3d_1 = lazy(FunnelSummary_successAfterError$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w3d_1 = lazy(FunnelSummary_successAfterError$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x3d_1 = lazy(FunnelSummary_successAfterError$annotations$delegate$lambda);
        this.y3d_1 = 0.0;
        this.z3d_1 = '0f';
      }
      k20() {
        var tmp0 = this.v3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelSummary_successAfterError$_get_name_$ref_mh3owj(), null);
        return tmp0.f2();
      }
      r3c(receiver) {
        return receiver.x3c_1;
      }
      m2j(receiver) {
        return this.r3c(receiver instanceof FunnelSummary() ? receiver : THROW_CCE());
      }
      u3d(receiver, value) {
        return receiver.c3d(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FunnelSummary() ? receiver : THROW_CCE();
        return this.u3d(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelSummary_successAfterError$_get_serializer_$ref_sia7bo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x3d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelSummary_successAfterError$_get_annotations_$ref_njzc48(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelSummary_successAfterError', VOID, VOID, [SerializableProperty()]);
    FunnelSummary_successAfterErrorClass = $;
  }
  return FunnelSummary_successAfterErrorClass;
}
var FunnelSummary_successAfterError_instance;
function FunnelSummary_successAfterError_getInstance() {
  if (FunnelSummary_successAfterError_instance === VOID)
    new (FunnelSummary_successAfterError())();
  return FunnelSummary_successAfterError_instance;
}
function FunnelSummary_error$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function FunnelSummary_error$_get_name_$ref_i6aqxy() {
  return (p0) => p0.k20();
}
function FunnelSummary_error$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelSummary_error$_get_serializer_$ref_6u23rh() {
  return (p0) => p0.j2j();
}
function FunnelSummary_error$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function FunnelSummary_error$_get_annotations_$ref_ew658v() {
  return (p0) => p0.bz();
}
var FunnelSummary_errorClass;
function FunnelSummary_error() {
  if (FunnelSummary_errorClass === VOID) {
    class $ {
      constructor() {
        FunnelSummary_error_instance = this;
        var tmp = this;
        tmp.a3e_1 = lazy(FunnelSummary_error$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b3e_1 = lazy(FunnelSummary_error$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c3e_1 = lazy(FunnelSummary_error$annotations$delegate$lambda);
        this.d3e_1 = 0.0;
        this.e3e_1 = '0f';
      }
      k20() {
        var tmp0 = this.a3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelSummary_error$_get_name_$ref_i6aqxy(), null);
        return tmp0.f2();
      }
      r3c(receiver) {
        return receiver.y3c_1;
      }
      m2j(receiver) {
        return this.r3c(receiver instanceof FunnelSummary() ? receiver : THROW_CCE());
      }
      u3d(receiver, value) {
        return receiver.c3d(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FunnelSummary() ? receiver : THROW_CCE();
        return this.u3d(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelSummary_error$_get_serializer_$ref_6u23rh(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelSummary_error$_get_annotations_$ref_ew658v(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelSummary_error', VOID, VOID, [SerializableProperty()]);
    FunnelSummary_errorClass = $;
  }
  return FunnelSummary_errorClass;
}
var FunnelSummary_error_instance;
function FunnelSummary_error_getInstance() {
  if (FunnelSummary_error_instance === VOID)
    new (FunnelSummary_error())();
  return FunnelSummary_error_instance;
}
function FunnelSummary_abandoned$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function FunnelSummary_abandoned$_get_name_$ref_cpu3ea() {
  return (p0) => p0.k20();
}
function FunnelSummary_abandoned$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelSummary_abandoned$_get_serializer_$ref_4sjujd() {
  return (p0) => p0.j2j();
}
function FunnelSummary_abandoned$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function FunnelSummary_abandoned$_get_annotations_$ref_mmk98j() {
  return (p0) => p0.bz();
}
var FunnelSummary_abandonedClass;
function FunnelSummary_abandoned() {
  if (FunnelSummary_abandonedClass === VOID) {
    class $ {
      constructor() {
        FunnelSummary_abandoned_instance = this;
        var tmp = this;
        tmp.f3e_1 = lazy(FunnelSummary_abandoned$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g3e_1 = lazy(FunnelSummary_abandoned$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h3e_1 = lazy(FunnelSummary_abandoned$annotations$delegate$lambda);
        this.i3e_1 = 0.0;
        this.j3e_1 = '0f';
      }
      k20() {
        var tmp0 = this.f3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelSummary_abandoned$_get_name_$ref_cpu3ea(), null);
        return tmp0.f2();
      }
      r3c(receiver) {
        return receiver.z3c_1;
      }
      m2j(receiver) {
        return this.r3c(receiver instanceof FunnelSummary() ? receiver : THROW_CCE());
      }
      u3d(receiver, value) {
        return receiver.c3d(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FunnelSummary() ? receiver : THROW_CCE();
        return this.u3d(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelSummary_abandoned$_get_serializer_$ref_4sjujd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelSummary_abandoned$_get_annotations_$ref_mmk98j(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelSummary_abandoned', VOID, VOID, [SerializableProperty()]);
    FunnelSummary_abandonedClass = $;
  }
  return FunnelSummary_abandonedClass;
}
var FunnelSummary_abandoned_instance;
function FunnelSummary_abandoned_getInstance() {
  if (FunnelSummary_abandoned_instance === VOID)
    new (FunnelSummary_abandoned())();
  return FunnelSummary_abandoned_instance;
}
function FunnelSummary_count$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function FunnelSummary_count$_get_name_$ref_jjewxf() {
  return (p0) => p0.k20();
}
function FunnelSummary_count$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FunnelSummary_count$_get_serializer_$ref_3vk5vw() {
  return (p0) => p0.j2j();
}
function FunnelSummary_count$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function FunnelSummary_count$_get_annotations_$ref_x1jxyw() {
  return (p0) => p0.bz();
}
var FunnelSummary_countClass;
function FunnelSummary_count() {
  if (FunnelSummary_countClass === VOID) {
    class $ {
      constructor() {
        FunnelSummary_count_instance = this;
        var tmp = this;
        tmp.k3e_1 = lazy(FunnelSummary_count$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l3e_1 = lazy(FunnelSummary_count$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m3e_1 = lazy(FunnelSummary_count$annotations$delegate$lambda);
        this.n3e_1 = 0;
        this.o3e_1 = '0';
      }
      k20() {
        var tmp0 = this.k3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FunnelSummary_count$_get_name_$ref_jjewxf(), null);
        return tmp0.f2();
      }
      r3c(receiver) {
        return receiver.a3d_1;
      }
      m2j(receiver) {
        return this.r3c(receiver instanceof FunnelSummary() ? receiver : THROW_CCE());
      }
      p3e(receiver, value) {
        return receiver.c3d(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FunnelSummary() ? receiver : THROW_CCE();
        return this.p3e(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FunnelSummary_count$_get_serializer_$ref_3vk5vw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FunnelSummary_count$_get_annotations_$ref_x1jxyw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FunnelSummary_count', VOID, VOID, [SerializableProperty()]);
    FunnelSummary_countClass = $;
  }
  return FunnelSummary_countClass;
}
var FunnelSummary_count_instance;
function FunnelSummary_count_getInstance() {
  if (FunnelSummary_count_instance === VOID)
    new (FunnelSummary_count())();
  return FunnelSummary_count_instance;
}
//region block: exports
export {
  prepareFunnelSummaryFields as prepareFunnelSummaryFields2gae6rz3ojln2,
};
//endregion

//# sourceMappingURL=FunnelSummaryFields.mjs.map
